import React from "react";
import "./Home.scss";

import Hero from "../../components/hero/Hero";
import WhatWeBuild from "../../components/whatwebuild/WhatWeBuild";
import TechnologyStack from "../../components/technologystack/TechnologyStack";
import UseCases from "../../components/usecases/UseCases";
import Indicators from "../../components/indicators/Indicators";
import Testimonials from "../../components/testimonials/Testimonials";
import Clients from "../../components/clients/Clients";
import ContactCTA from "../../components/contactcta/ContactCTA";
import MapSection from "../../components/mapsection/MapSection";

const Home = () => {
    return (
        <div className="home-page">
            <Hero />
            <WhatWeBuild />
            <TechnologyStack />
            <UseCases />
            <Indicators />
            <Testimonials />
            <Clients />
            <ContactCTA />
            <MapSection />
        </div>
    );
};

export default Home;